import React, { Component } from 'react';


class Later extends Component {
    render() {
        return(
            <div className="later">
                You could check back later to see if this is for sale or expires.
            </div>
        );
    }
}

export default Later;


// WEBPACK FOOTER //
// ./src/components/later.js